<div class="control-bar" #controlBar>
  <div class="buttons-container">
    <button mat-icon-button mat-medium-icon-button class="toggle-play-button" (click)="togglePlay()">
      @if (isPlaying) {
        <mat-icon>pause</mat-icon>
      } @else {
        <mat-icon>play_arrow</mat-icon>
      }
    </button>
    @if (isActive('PLAYBACK_RATE')) {
      <button
        mat-icon-button
        mat-medium-icon-button
        [matTooltip]="'CALLS.CHANGE_PLAYBACK_RATE' | translate"
        class="playback-rate-button"
        (click)="changePlayBackRate()"
      >
        {{ playbackRate }}x
      </button>
    }
    @if (isActive('NEXT_SPEAKER')) {
      <button
        mat-icon-button
        mat-medium-icon-button
        [matTooltip]="'CALLS.JUMP_TO_NEXT_SPEAKER' | translate"
        class="jump-to-next-speaker-button"
        (click)="handleJumpToNextSpeaker()"
      >
        <mat-icon>skip_next</mat-icon>
      </button>
    }
    @if (isActive('SKIP_30_SECONDS')) {
      <button
        mat-icon-button
        mat-medium-icon-button
        [matTooltip]="'CALLS.SKIP_30_SECONDS' | translate"
        class="skip-30-seconds-button"
        (click)="handleSkipSeconds(30)"
      >
        <mat-icon>forward_30</mat-icon>
      </button>
    }
    @if (isActive('MISC')) {
      <button
        mat-icon-button
        mat-medium-icon-button
        [matTooltip]="'CALLS.SHOW_SPEAKER_X_RAY' | translate"
        (click)="handleShowSpeakers()"
        [class.dimmed]="isShowingSpeakers"
      >
        <mat-icon>group</mat-icon>
      </button>
    }
    @if (displaySpeakerLabelingModeButton && isActive('MISC')) {
      <button
        mat-icon-button
        mat-medium-icon-button
        [matTooltip]="'CALLS.ENABLE_SPEAKER_LABELING_MODE' | translate"
        (click)="toggleSpeakerLabelingMode()"
        [class.dimmed]="isSpeakerLabelingModeEnabled"
      >
        <mat-icon>manage_accounts</mat-icon>
      </button>
    }
  </div>
  <div class="progress-container">
    @if (isActive('MISC')) {
      <div class="time">{{ formatPlayerTime(currentTime) }}</div>
    }
    @if (duration) {
      <div class="progress-bar">
        <mat-slider min="0" [max]="duration">
          <input matSliderThumb [value]="currentTime" (input)="onSliderChange($event)" />
        </mat-slider>
        <div class="pause-markers">
          @for (pauseOffset of pauseOffsets; track pauseOffset) {
            <div class="pause-marker" [class.past]="currentTime > pauseOffset" [style.left.%]="(pauseOffset / duration) * 100"></div>
          }
        </div>
      </div>
      @if (isActive('MISC')) {
        <div class="time">{{ formatPlayerTime(duration) }}</div>
      }
    }
  </div>

  <div class="volume-container">
    @if (isActive('MUTE')) {
      <button mat-icon-button mat-medium-icon-button (click)="toggleMute()">
        <mat-icon>{{ isMuted ? 'volume_off' : 'volume_up' }}</mat-icon>
      </button>
    }
  </div>

  @if (displayFullscreenButton && isActive('MISC')) {
    <button mat-icon-button mat-medium-icon-button class="full-screen-button" (click)="onToggleFullscreen()">
      <mat-icon>fullscreen</mat-icon>
    </button>
  }
  @if (allowDownload && isActive('DOWNLOAD')) {
    <button mat-icon-button mat-medium-icon-button [matTooltip]="'COMMON.DOWNLOAD' | translate" (click)="download.emit()">
      <mat-icon>download</mat-icon>
    </button>
  }
  @if (displayMenuButton) {
    <div class="menu">
      <button mat-icon-button mat-medium-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>more_horiz</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        @if (!isActive('PLAYBACK_RATE')) {
          <button
            mat-icon-button
            mat-medium-icon-button
            style="color: gray"
            [matTooltip]="'CALLS.CHANGE_PLAYBACK_RATE' | translate"
            (click)="$event.stopPropagation(); changePlayBackRate()"
          >
            {{ playbackRate }}x
          </button>
        }
        @if (!isActive('NEXT_SPEAKER')) {
          <button mat-icon-button mat-medium-icon-button [matTooltip]="'CALLS.JUMP_TO_NEXT_SPEAKER' | translate" (click)="handleJumpToNextSpeaker()">
            <mat-icon>skip_next</mat-icon>
          </button>
        }
        @if (!isActive('MUTE')) {
          <button mat-icon-button mat-medium-icon-button (click)="toggleMute()">
            <mat-icon>{{ isMuted ? 'volume_off' : 'volume_up' }}</mat-icon>
          </button>
        }
        @if (allowDownload && !isActive('DOWNLOAD')) {
          <button mat-icon-button mat-medium-icon-button [matTooltip]="'COMMON.DOWNLOAD' | translate" (click)="download.emit()">
            <mat-icon>download</mat-icon>
          </button>
        }
        @if (displayFullscreenButton && !isActive('MISC')) {
          <button mat-icon-button mat-medium-icon-button (click)="onToggleFullscreen()">
            <mat-icon>fullscreen</mat-icon>
          </button>
        }
        @if (!isActive('MISC')) {
          <button mat-icon-button mat-medium-icon-button [matTooltip]="'CALLS.SHOW_SPEAKER_X_RAY' | translate" (click)="handleShowSpeakers()">
            <mat-icon>group</mat-icon>
          </button>
        }
      </mat-menu>
    </div>
  }
</div>
